import request from './http';

// 保存岗位信息
export const addPostData = ( data ) => {
    return request({
        url: '/auth/position/addPositionInfo',
        method: 'post',
        data
    })
}

// 删除岗位信息
export const deletePostData = ( data ) => {
    return request({
        url: '/auth/position/deletePosition?companyId='+data.companyId+"&positionId="+data.positionId,
        method: 'get',
    })
}

// 修改岗位信息
export const changePostData = ( data ) => {
    return request({
        url: '/auth/position/modifyPosition',
        method: 'post',
        data
    })
}

// 分页查询岗位信息
export const getPostDataList = ( data ) => {
    return request({
        url: '/auth/position/pageFindPositionInfo',
        method: 'post',
        data
    })
}

// 更新岗位状态信息
export const changePostStatus = data => {
    return request({
        url: '/auth/position/updatePositionStatus?companyId='+data.companyId+"&positionId="+data.positionId+"&positionStatus="+data.positionStatus,
        method: 'get',
    })
}

// 获取所有系统信息
export const findPageCompany = data => {
    return request({
        method: 'get',
        url: '/auth/copy/findByDelFlagInfo'
    })
}

// 复制岗位信息
export const copyPosition = data => {
    return request({
        method: 'get',
        url: '/auth/copy/copyPositionInfo?companyId='+data.companyId+"&oldCompanyId="+data.oldCompanyId
    })
}

// 查询权限-岗位信息
export const getPositionTree = data => {
    return request({
        method: 'get',
        url: '/auth/position/findTreePositionInfo?companyId='+data.companyId+"&userCode="+data.userCode
    })
}